export function sortByKey(a: { key: string }, b: { key: string }) {
  let value1 = a.key?.toLowerCase();
  let value2 = b.key?.toLowerCase();

  return value1 > value2 ? 1 : value1 < value2 ? -1 : 0;
}
